import { Field, useField, useForm } from 'react-final-form';
import styles from './FileItem.module.scss';
import { RiCloseFill as RemoveIcon } from 'react-icons/ri'
import { VscFilePdf as PdfIcon } from 'react-icons/vsc';
import { useCallback, useContext, useState } from 'react';
import { UnderwritingFormContext } from '../../context/UnderwritingFormContext';
import { ApplicationContextType, MonthlyReportSteps, UnderwritingSteps, uploadStates } from '../../../../interfaces/interfaces';
import CircularLoader from '../../../../components/common/CircularLoader/CircularLoader';
import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';
import PdfPasswordProtection from './PdfPasswordProtection';
import { getIn } from 'final-form';
import { MonthlyReportFormContext } from '../../../MonthlyReport/context/MonthlyReportFormContext';
import moment from 'moment';
import API from '../../../../rest/api';


type Props = {
    fieldName: string;
    /** Stable lookup key for underwritingFileJobs; defaults to fieldName for callers that don't need position-independent keying. */
    jobKey?: string;
    fieldIndex: number;
    stepType: UnderwritingSteps | MonthlyReportSteps;
    outerFieldName: string;
    newUploadedDocIds: number[];
    setNewUploadedDocIds: React.Dispatch<React.SetStateAction<number[]>>;
    deleteDocIds: number[],
    setDeleteDocIds: React.Dispatch<React.SetStateAction<number[]>>;
    isJobProcessing?: boolean;
    contextType?: ApplicationContextType;
}


const FileItem = ({ fieldName, jobKey = fieldName, stepType, outerFieldName, setDeleteDocIds, setNewUploadedDocIds, deleteDocIds, newUploadedDocIds, fieldIndex, isJobProcessing, contextType = ApplicationContextType.underwriting }: Props) => {

    const { handleUnderwritingFileJobs, underwritingFileJobs, underwritingFileJobsByDocId, sendFileJobToApi } = useContext(contextType == ApplicationContextType?.monthlyReport ? MonthlyReportFormContext : UnderwritingFormContext);
    const [showPasswordSuccess, setShowPasswordSuccess] = useState(false);
    const [isPreviewLoading, setIsPreviewLoading] = useState(false);
    const { getState, mutators } = useForm()

    // console.log('fieldName', fieldName);

    const getJobDetails = useCallback((jobKey) => {
        const jobDetails = underwritingFileJobs?.[stepType]?.[jobKey] ?? null;
        // console.log('jobDetails', jobDetails);
        return jobDetails;
    }, [underwritingFileJobs]);

    const getJobDetailsByDocId = useCallback((docId): any => {
        if (!docId) return null;
        return underwritingFileJobsByDocId?.[stepType]?.[docId] ?? null;
    }, [underwritingFileJobsByDocId, stepType]);

    const handlePasswordSubmit = (password: string) => {
        setShowPasswordSuccess(true);
        const fileJobDetails = getJobDetails(jobKey);
        sendFileJobToApi(stepType, jobKey, {
            ...fileJobDetails,
            fileMetaData: {
                ...fileJobDetails.fileMetaData,
                password: password,
            },
            status: uploadStates.doneUploading,
        });
    }

    // const { input: { value: fileUploadedValue } } = useField(`${fieldName}`, { subscription: { value: true } });
    // console.log('fieldName', fieldName);
    const fileUploadedValue = getIn(getState()?.values, `${fieldName}`)

    // console.log('fileUploadedValue', fileUploadedValue?.selectedFile?.name);

    const formatActualPeriod = (actualPeriod: string[]) => {
        if (!actualPeriod || actualPeriod?.length < 2) return null;
        const startDate = moment(actualPeriod[0], ['YYYY-MM-DD', 'DD-MM-YYYY'], true);
        const endDate = moment(actualPeriod[1], ['YYYY-MM-DD', 'DD-MM-YYYY'], true);
        if (!startDate.isValid() || !endDate.isValid()) return null;
        const sameYear = startDate.isSame(endDate, 'year');
        return `${startDate.format(sameYear ? 'MMM D' : 'MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`;
    }

    const actualPeriodText = formatActualPeriod(getJobDetailsByDocId(fileUploadedValue?.uploadedFile?.docId)?.fileMetaData?.documentPeriod?.actualPeriod);

    const openBlobUrlAndScheduleRevoke = (blobUrl: string) => {
        window.open(blobUrl, '_blank');
        setTimeout(() => URL.revokeObjectURL(blobUrl), 60 * 60 * 1000);
    }

    const handlePreviewFile = async () => {
        if (isPreviewLoading) return;
        try {
            setIsPreviewLoading(true);
            if (fileUploadedValue?.selectedFile instanceof File) {
                openBlobUrlAndScheduleRevoke(URL.createObjectURL(fileUploadedValue.selectedFile));
                return;
            }
            const fileKey = fileUploadedValue?.uploadedFile?.fileKey;
            if (!fileKey) return;
            const response = await API.post('/underwriting/uploadjob/fetchfile', {
                fileKey,
            }, {
                responseType: 'blob',
            });
            const blobUrl = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            openBlobUrlAndScheduleRevoke(blobUrl);
        } catch (error) {
            console.log('error previewing file', error);
        } finally {
            setIsPreviewLoading(false);
        }
    }

    return (
        // <Field name={`${fieldName}`}>
        //     {(props) => {
        //         return (
        <>
            {contextType == ApplicationContextType.monthlyReport && fileUploadedValue?.uploadedFile?.isOldFile ?
                null
                :
                <div className={styles.fileItemRootContainer}>

                    <div className={styles.fileItemContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.iconContainer}>
                                <PdfIcon />
                            </div>
                            <div className={styles.fileNameContainer}>
                                <div className={styles.fileName}>
                                    {fileUploadedValue.selectedFile instanceof File ? fileUploadedValue?.selectedFile?.name : fileUploadedValue?.uploadedFile?.fileName}
                                </div>
                                {actualPeriodText ?
                                    <div className={styles.filePeriod}>
                                        {actualPeriodText}
                                    </div> : null}
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            <div className={styles.previewFile} onClick={handlePreviewFile}>
                                Preview
                            </div>
                            {getJobDetails(jobKey)?.status == uploadStates.uploading || isJobProcessing ?
                                <CircularLoader />
                                : <MeritoButton
                                    type='tertiary'
                                    onlyIcon={true}
                                    icon={<RemoveIcon />}
                                    onClick={() => {
                                        // if (isJobProcessing) return;
                                        console.log('outerFieldName', outerFieldName, fieldIndex);
                                        console.log('fileUploadedValue', fileUploadedValue);
                                        setDeleteDocIds(prev => [...prev, fileUploadedValue.uploadedFile?.docId]);
                                        mutators.remove(outerFieldName, fieldIndex);
                                    }}
                                />}
                        </div>
                    </div>

                    {getJobDetails(jobKey)?.status == uploadStates.requiredPassword || showPasswordSuccess ?
                        <PdfPasswordProtection showPasswordSuccess={showPasswordSuccess} fileDetails={fileUploadedValue} handleSubmitPassword={(password) => handlePasswordSubmit(password)} />
                        : null}
                </div>}
        </>
    );
}

export default FileItem;